import React, { useState } from 'react'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { Input } from 'alurkerja-ui'
import { useUiFromSpecContext } from '../../../EditorContextProvider'
import { getElementDisplayName } from '../../utils/getElementDisplayName'

type EditNameFieldProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditNameField(props: EditNameFieldProps) {
  const { setDisableSaveEdit } = useUiFromSpecContext()
  const { index, element, currentElementState, setCurrentElementState } = props
  const [hasSpaceError, setHasSpaceError] = useState(false)

  const validateInput = (value: string) => {
    // Check if input contains spaces
    setHasSpaceError(value.includes(' '))
    setDisableSaveEdit?.(value.includes(' '))
    return value
  }

  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{stringToTitleCase(getElementDisplayName(element))}</span>
      <Input
        className={`w-full ${hasSpaceError ? 'border-red-500' : ''}`}
        type="text"
        size="sm"
        rounded="lg"
        value={currentElementState[element]}
        onChange={(e) => {
          const newValue = e.target.value
          validateInput(newValue)
          setCurrentElementState((prevState: any) => {
            return {
              ...prevState,
              [element]: newValue,
            }
          })
        }}
      />
      {hasSpaceError && <div className="text-red-500 text-sm mt-1">Spaces are not allowed in this field</div>}
    </div>
  )
}
